<template>
  <div class="report-wrap">
    <div class="content">
      <div class="title-wrap">
        <div class="col-blue"></div>
        <time-search
          ref="timeSearch"
          :control="{ data: timeData }"
          @timeControlChange="timeControlChange"
          @timeControlClick="TimeControlClick"
          :showExportBtn="true"
          :showPrint="true"
          :showPrintId="'table'"
          :showPrintTitle="statementName"
          @exportExc="bindExportExc"
        >
          <!-- <el-button
                    style="height: 30px;line-height: 0px;"
                    ref="print"
                    type="primary"
                    class="btn"
                    v-print="'#single-info'"  
                    @click="prints"
                >打印</el-button> -->
          <label style="margin: 0 5px">报表名称</label>
          <el-select
            style="width: 180px"
            v-model="statementId"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(item, index) in leftTable"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </time-search>
        <div></div>
      </div>
      <div class="table-content box" style="flex: 1; display: flex">
        <TableV1 ref="Table" v-if="version === '1'"></TableV1>
        <TableV2 ref="Table" v-else></TableV2>
      </div>
    </div>
  </div>
</template>

<script>
import { exportExcel } from "@/utils/index.js";
import TimeSearch from "@/components/common/TimeSearch.vue";
import DateTool from "@/utils/dateTool";
import TableV1 from "./Configuration/TableV1";
import TableV2 from "./Configuration/Table";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  components: { TimeSearch, TableV1, TableV2 },
  data() {
    return {
      timeData: allTimeData,
      selectedDate: {},
      tableData: [],
      columns: [
        {
          label: "序号",
          fixed: "left",
          show: true,
          width: "100",
          type: "index",
          align: "center",
        },
      ],
      columnsIndex: null, //横向表头索引
      leftTable: [],
      isSelect: 0,
      rowsData: [],
      columnsData: [],
      statementId: "",
      statementName: "",
      showPrintTitle: "报表分析",
      configColumns: [],

      version: "2",
    };
  },
  created() {
    let vm = this;
    let time = new Date();
    let startTime = DateTool.format(time, "yyyy-MM-dd ") + "00:00:00";
    time.setDate(time.getDate() + 1);
    let endTime = DateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
    vm.selectedDate = {
      dataType: "1",
      dateType: "day",
      endTime: endTime,
      startTime: startTime,
    };
    vm.TimeControlClick(vm.selectedDate);
    // vm.getUserDefinedStatements(true);
  },
  watch: {
    statementId(val) {
      this.leftTable.forEach((item) => {
        if (item.id == val) {
          this.statementName = item.name;
        }
      });
      this.statementId = val;
    },
  },
  methods: {
    timeControlChange() {},
    //查询事件
    TimeControlClick(e) {
      let vm = this;
      vm.selectedDate = e;
      vm.getData();
    },
    getData() {
      this.getUserDefinedStatements();
    },
    //获取左边数据
    async getUserDefinedStatements(type) {
      let vm = this;
      let resUer = await vm.$api.statement.getUserDefinedStatements(0);
      vm.leftTable = resUer.data;
      if (vm.leftTable.length > 0) {
        if (!vm.statementId) {
          vm.statementId = vm.leftTable[0].id;
          vm.statementName = vm.leftTable[0].name;
        }
        // this.generateUserDefinedStatementDataDay();
        await vm.getUserDefinedStatementConfig();
      }
    },
    //获取表格数据
    async getUserDefinedStatementConfig() {
      let vm = this;
      let res = null;
      if (vm.selectedDate.dateType == "day") {
        res = await vm.$api.statement.generateUserDefinedStatementDataDay(
          vm.statementId,
          DateTool.format(new Date(vm.selectedDate.startTime), "yyyy-MM-dd") +
            " 00:00:00"
        );
      } else if (vm.selectedDate.dateType == "month") {
        res = await vm.$api.statement.generateUserDefinedStatementDataMonth(
          vm.statementId,
          DateTool.format(new Date(vm.selectedDate.startTime), "yyyy-MM") +
            "/01 00:00:00"
        );
      } else {
        res = await vm.$api.statement.generateUserDefinedStatementDataYear(
          vm.statementId,
          DateTool.format(new Date(vm.selectedDate.startTime), "yyyy") +
            "/01/01 00:00:00"
        );
      }

      const resConfig = await vm.$api.statement.getUserDefinedStatementConfig(
        this.statementId
      );
      let config = null;
      if (resConfig && resConfig) {
        if (resConfig.data.constructor !== Array) {
          config = JSON.parse(resConfig.data);
        }
      }
      if (config) {
        if (config.version) {
          this.version = config.version;
        } else {
          this.version = "1";
        }
      } else {
        this.version = "2";
      }

      let tableData = [];
      if (res || res.data) {
        tableData = res.data;
      }
      this.tableData = tableData;
      this.$nextTick(() => {
        this.$refs["Table"].init(config, tableData);
      });
    },
    noData() {
      this.tableData = [];
      this.columns = [
        {
          label: "序号",
          fixed: "left",
          show: true,
          width: "100",
          type: "index",
          align: "center",
        },
      ];
    },
    bindExportExc() {
      //表格导出
      exportExcel("table", this.statementName, this.selectedDate);
    },
  },
};
</script>
<style lang="scss" scoped>
@page {
  size: auto; /* auto is the initial value */
  margin: 0mm; /* this affects the margin in the printer settings */
}
.btn {
  background: #5fa4e8;
  color: #fff;
}
.black {
  color: #fff;
}
.report-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  text-align: left;
  .content {
    background: #ffffff;
    padding: 0px 6px;
    box-sizing: border-box;
    display: flex;
    flex-flow: column;
    width: 100%;
  }
  .title-wrap {
    width: 100%;
    height: 50px;
    line-height: 40px;
    border-bottom: 1px solid rgb(214, 214, 214);
    color: #000;
    display: flex;
    align-items: center;
    .col-blue {
      width: 4px;
      height: 20px;
      //   background: rgb(101, 128, 216);
      margin-right: 6px;
    }
    .title-content {
      font-weight: bold;
    }
  }
  .list1 {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    color: #000;
    .item {
      display: flex;
      align-items: center;
      border: 1px solid #5f5f5f;
      padding: 0px 6px;
      margin: 5px;
      .item-title {
        margin-right: 10px;
      }
    }
  }
}
.rows {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.addRow {
  margin-left: 67px;
  border: 1px dashed #797979;
  text-align: center;
  padding: 5px;
  margin-right: 87px;
  cursor: pointer;
}
.addRow1 {
  margin-left: 38px;
  border: 1px dashed #797979;
  text-align: center;
  padding: 5px;
  margin-right: 18px;
  cursor: pointer;
}
.maxHeight {
  max-height: 350px;
  overflow: auto;
}
.treeBox {
  max-height: 450px;
  overflow: auto;
}
.layou-container {
  overflow: none;
  text-overflow: none;
  white-space: "";
}
.verticalSave {
  margin-left: 262px;
  margin-top: 10px;
}
.mesureName {
  max-width: 200px;
  white-space: break-spaces;
  margin-right: 7px;
}
.time-warp {
  width: 100%;
  height: 100%;
  padding: 0px 10px;
  box-sizing: border-box;
  align-items: center;
  display: flex;
}
</style>
